export enum InputValidationStyle {
	Error = "Error",
	Warning = "Warning",
	Loading = "Loading",
	Success = "Success",
}
